import _ from "lodash";
import React from "react";
import classes from "./DropDown.scss";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import { useTranslation } from "react-i18next";
import ACLStore from "lib/aclStore";
import { DotsHorizontalOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";

const buttonDropDownContainerStyle = {
  marginTop: -12,
  minWidth: 120,
  width: "max-content",
  right: 0,
};

const buttonDropDownItemStyle = {
  height: 32,
};

const changeLocale = (menuItems, t) => {
  const menus = [];
  _.forEach(menuItems, element => {
    const { label, perm } = element;
    if (!perm || ACLStore.can(perm, "all")) {
      menus.push({ ...element, label: t(label) });
    }
  });
  return menus;
};

const DropDown = ({
  item,
  onDeleteClick,
  onEditClick,
  onDuplicateClick,
  onPrintClick,
}) => {
  const menuItems = [
    {
      label: "edit",
      clickAction: () => {
        onEditClick({ id: item.id, mode: "edit" });
      },
      svg: null,
      isDisable: false,
    },
    {
      label: "duplicate",
      clickAction: () => {
        onDuplicateClick(item);
      },
      svg: null,
      isDisable: false,
    },
    {
      label: "print",
      clickAction: () => {
        onPrintClick(item);
      },
      svg: null,
      isDisable: false,
    },
    {
      label: "delete",
      clickAction: () => {
        onDeleteClick(item);
      },
      svg: null,
      isDisable: false,
    },
  ];

  const { t } = useTranslation("common");

  return (
    <div className={classes.container}>
      <ButtonDropdown
        authTabs={changeLocale(menuItems, t)}
        containerStyle={buttonDropDownContainerStyle}
        buttonParentStyle={{ padding: "0px 16px", marginRight: "-16px" }}
        itemStyle={buttonDropDownItemStyle}
        buttonComponent={
          <IconButton
            size="medium"
            icon={<DotsHorizontalOutlined />}
            variant="plain"
          />
        }
      />
    </div>
  );
};

export default DropDown;
